export const SET_BOOKING = "BOOKINGS/SET_BOOKING" 